import { NetzTranslateService } from 'src/app/services/netz-translate.service';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RegistrationService } from '../registration.service';
import { ApplicationResponseData, DateFormat } from '../../domains/common.domain';
import { Companies } from '../../model/companies';
import { LocalStorageService } from '../../services/local-storage.service';
import { ConcessionStatus, FileData, FormatterData, UserRoles } from '../../constants/app.constants';
import { CommunicationService } from '../../services/communication.service';
import { ConfirmationService, SelectItem } from 'primeng';
import { FileService } from '../../services/file.service';
import { DocumentData } from '../../employee-overview/employee-overview.domain';
import { LookupOptionsData } from '../../jurisdiction/jurisdiction.domain';
import { AllDropdownKeys } from '../../jurisdiction/jurisdiction.constants';
import { CommonService } from '../../services/common.service';
import { EnvironmentService } from '../../services/environment.service';
import {
  MandatoryDocumentsByQualificationAndCommodity,
  MandatoryDocumentsPerCommodity,
  OptionalDocumentsByCommodity,
  OptionalDocumentsByQualification,
} from 'src/app/interface/config.interface';
import { ValidationsService } from 'src/app/services/validations.service';
import { BasicProfileRouteData } from './basic-profile.domain';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { UserService } from 'src/app/services/user.service';

const readonlyApplicationStatuses = [ConcessionStatus.renew_requested, ConcessionStatus.submitted];

@Component({
  selector: 'app-basic-profile',
  templateUrl: './basic-profile.component.html',
  styleUrls: ['./basic-profile.component.scss'],
})
export class BasicProfileComponent extends DestroyableComponent implements OnInit, OnDestroy {
  dateFormat: DateFormat = FormatterData.date;
  companyDataFG: FormGroup;
  technicianDataFG: FormGroup;
  checkDataFG: FormGroup;
  educationInformationDataFG: FormGroup;

  _technicianApplication: any;
  set technicianApplication(value: any) {
    this._technicianApplication = value;
    this.isReadonly = readonlyApplicationStatuses.includes(value.status);
  }
  get technicianApplication(): any {
    return this._technicianApplication;
  }

  documents: any;
  titleKey: string = AllDropdownKeys.Title;
  allTitles: LookupOptionsData[] = this.commonService.getDropdownData(AllDropdownKeys.Title);
  companyExist: boolean = false;

  taId: string;
  companyId: string;
  technicianId: string;
  submitted: boolean = false;
  commodities = ['power', 'gas', 'water', 'heating'];
  options: SelectItem[];
  isLoading: boolean;
  allDocumentsResultingOfEmptyChecks: boolean;
  optionalDocumentsTypes: Set<string> = new Set<string>();
  takeMandatoryDocumentsTypes: Set<string> = new Set<string>();
  specialistMandatoryDocumentsTypes: Set<string> = new Set<string>();
  mandatoryDocumentsPerCommodity: MandatoryDocumentsPerCommodity = this.environmentService.mandatoryDocumentsPerCommodity;
  mandatoryDocumentsByQualificationAndCommodity: MandatoryDocumentsByQualificationAndCommodity[] =
    this.environmentService.mandatoryDocumentsByQualificationAndCommodity;
  optionalDocumentsByCommodity: OptionalDocumentsByCommodity[] = this.environmentService.optionalDocumentsByCommodity;
  optionalDocumentsByQualification: OptionalDocumentsByQualification[] = this.environmentService.optionalDocumentsByQualification;
  showBaseDataEmail: boolean = this.environmentService.showBaseDataEmail;
  showTechnicianDataEmail: boolean = this.environmentService.showTechnicianDataEmail;
  showMastersExaminationOn: boolean = this.environmentService.showMastersExaminationOn;
  showMainBusinessesPartTimeRadioBtn: boolean = this.environmentService.showMainBusinessesPartTimeRadioBtn;
  showInAuxiliaryOperationRadioBtn: boolean = this.environmentService.showInAuxiliaryOperationRadioBtn;
  showHeatingWeldingCertificateConfirmation: boolean = this.environmentService.showHeatingWeldingCertificateConfirmation;
  showSafetyTechnologyExemptionDocument: boolean = this.environmentService.showSafetyTechnologyExemptionDocument;
  showSafetyTechnologyAuthorizationDocument: boolean = this.environmentService.showSafetyTechnologyAuthorizationDocument;
  showEducationInformationSection: boolean;
  isReadonly = false;
  ConcessionStatus = ConcessionStatus;
  fileChanged: boolean = false;
  showProofOfVdeSubscriptionDocument: boolean = this.environmentService.showProofOfVdeSubscriptionDocument;
  showCompanyDescription: boolean = false;
  showGuildMember: boolean = false;

  constructor(
    private registrationService: RegistrationService,
    private communicationService: CommunicationService,
    private localStorageService: LocalStorageService,
    private fileService: FileService,
    private ref: ChangeDetectorRef,
    private commonService: CommonService,
    private environmentService: EnvironmentService,
    private confirmationService: ConfirmationService,
    private translateService: NetzTranslateService,
    private userService: UserService
  ) {
    super();
    this.showCompanyDescription =
      this.environmentService.showCompanyDescription && this.userService.getUserRole() === UserRoles.standardTechnician;
    this.showGuildMember = this.environmentService.showGuildMember && this.userService.getUserRole() === UserRoles.standardTechnician;
  }

  @Input() routeData: BasicProfileRouteData;

  ngOnInit(): void {
    this.companyDataFG = this.registrationService.companyDataFG;
    this.technicianDataFG = this.registrationService.technicianDataFG;
    this.checkDataFG = this.registrationService.checkDataFG;
    this.educationInformationDataFG = this.registrationService.educationInformationDataFG;

    this.isLoading = true;
    this.options = [
      { label: 'select', value: '' },
      { label: 'master', value: 'Meister' },
      { label: 'engineer', value: 'Ingenieur' },
      { label: 'craft', value: 'Meister In anderem Handwerk' },
      { label: 'journeyman', value: 'Altgeselle' },
      { label: 'exemption', value: 'Ausnahmebewilligung' },
    ];

    this.setEducationInformationSectionVisibility();
    this.updateValidation();
    this.getTechnicianApplication();
    this.hideWaterCommodityIfNeeded();
    this.checkDataFG.markAsPristine();
    this.companyDataFG.markAsPristine();
    this.technicianDataFG.markAsPristine();
    this.educationInformationDataFG.markAsPristine();
  }

  getTechnicianApplication(): void {
    const technicianId: string = this.localStorageService.getItem('technician_id');
    this.registrationService.getTechnicianApplication(technicianId, 'technician_id').subscribe(
      (response: any) => {
        this.isLoading = false;
        if (response && response.technician_application && response.technician_application.length) {
          let birthday = response.technician_application[0].technician && response.technician_application[0].technician[0]?.birthday;
          if (birthday) {
            birthday = this.commonService.parseDateForUI(birthday);
            response.technician_application[0].technician[0].birthday = birthday;
          }
          this.setFormValues(response);
        } else {
          this.technicianDataFG.reset();
          this.saveTechnicianApplication(technicianId);
        }
        const checkData = this.checkDataFG.value;
        this.setRequiredDocuments(checkData);
        this.addMandatoryDocumentsByQualification(!checkData.power && !checkData.gas && !checkData.water && !checkData.heating);
        this.setOptionalDocuments();
        this.updateOptionalDocumentsByQualification();
      },
      error => {
        this.isLoading = false;
        if (error.status !== 0) {
          this.technicianDataFG.reset();
          this.saveTechnicianApplication(technicianId);
        }
      }
    );
  }

  saveTechnicianApplication(technicianId: string): void {
    const saveData = this.setTechnicianApplicationForm();
    this.registrationService.saveNewTechnicianApplication(saveData, technicianId).subscribe((response: any) => {
      if (response && response.created && response.created.length) {
        this.taId = response.created[0].ta_id;
        this.registrationService.getTechnicianApplication(this.taId, 'ta_id').subscribe((taResponse: any) => {
          this.setFormValues(taResponse);
        });
      }
    });
  }

  updateTechnician(commodityType?: string): void {
    const technician = { ...this.technicianDataFG.value };
    if (technician.birthday) {
      const birthday = technician.birthday;
      technician.birthday = this.commonService.parseDateForSaving(birthday);
    }
    if (technician.qualification_issued_on) {
      const qualificationIssuedOn = technician.qualification_issued_on;
      technician.qualification_issued_on = this.commonService.parseDateForSaving(qualificationIssuedOn);
    }
    const checkData = this.checkDataFG.value;
    this.setMandatoryDocuments(commodityType, this.checkDataFG.value);
    if (checkData !== null) {
      technician.concession_water = checkData.water ? '1' : '0';
      technician.concession_power = checkData.power ? '1' : '0';
      technician.concession_gas = checkData.gas ? '1' : '0';
      technician.concession_district_heating = checkData.heating ? '1' : '0';
      technician.welding_license = checkData.license === 'withLicense' ? '1' : '0';
      this.setEducationInformationSectionVisibility();
    }
    if (!checkData.heating) {
      checkData.license = null;
      technician.welding_license = '0';
      this.checkDataFG.patchValue(checkData);
    } else {
      if (checkData.license === null) {
        checkData.license = 'withoutLicense';
        this.checkDataFG.patchValue(checkData);
      }
    }
    if (!technician.is_guild_member) {
      technician.is_guild_member = null;
    }

    this.setOptionalDocuments();
    this.updateOptionalDocumentsByQualification();

    this.addEducationInformationData(technician);
    const updateData = {
      technician: [technician],
    };
    this.registrationService.updateTechnician(updateData, this.technicianId).subscribe(() => {});
  }

  getCompanyDetails(): void {
    const taxId = this.companyDataFG.get('tax_id').value;
    if (taxId) {
      this.communicationService.getCompany(taxId).subscribe((companies: Companies) => {
        if (companies.company && companies.company.length) {
          const companyData = companies.company[0];
          this.companyId = companyData.company_id;
          if (companyData.headoffice === 'true') {
            companyData.headsubsidiary = 'hauptbetrieb';
          }
          if (companyData.subsidiary === 'true') {
            companyData.headsubsidiary = 'nebenbetrieb';
          }
          if (companyData.main_businesses_part_time === 'true') {
            companyData.headsubsidiary = 'main_businesses_part_time';
          }
          if (companyData.in_auxiliary_operation === 'true') {
            companyData.headsubsidiary = 'in_auxiliary_operation';
          }
          this.companyDataFG.patchValue(companyData);
          this.updateTechnicianApplication(companyData.company_id);
          this.companyExist = true;
        } else {
          this.companyExist = false;
          this.companyDataFG.get('tax_id').setValue(taxId);
          this.saveNewCompany();
        }
      });
    } else {
      this.companyId = '';
      this.companyExist = false;
      this.companyDataFG.reset();
      const updateData = {
        company: [],
      };
      this.registrationService.updateTechnicianApplication(updateData, this.taId).subscribe(() => {});
    }
  }

  saveNewCompany(): void {
    const company = this.companyDataFG.value;
    company.headoffice = company.headoffice === 'hauptbetrieb' ? 'true' : 'false';
    company.subsidiary = company.subsidiary === 'nebenbetrieb' ? 'true' : 'false';
    company.main_businesses_part_time = company.main_businesses_part_time === 'main_businesses_part_time' ? 'true' : 'false';
    company.in_auxiliary_operation = company.in_auxiliary_operation === 'in_auxiliary_operation' ? 'true' : 'false';
    const companyData = {
      company: [company],
    };
    this.registrationService.saveCompany(companyData).subscribe((savedCompany: any) => {
      if (savedCompany && savedCompany.created && savedCompany.created.length) {
        this.companyId = savedCompany.created[0].company_id;
        this.updateTechnicianApplication(this.companyId);
      }
    });
  }

  updateQualificationTechnicianApplication(): void {
    this.setRequiredDocuments(this.checkDataFG.value);
    this.setOptionalDocuments();
    this.addMandatoryDocumentsByQualification();
    this.updateOptionalDocumentsByQualification();
  }

  updateTechnicianApplication(companyId: string): void {
    const updateData = {
      technician_application: [
        {
          company_id: companyId,
        },
      ],
    };
    this.registrationService.updateTechnicianApplication(updateData, this.taId).subscribe(() => {
      this.getTechnicianApplication();
    });
  }

  updateCompany(): void {
    if (this.companyId) {
      const company = this.companyDataFG.value;
      company.headoffice = company.headsubsidiary === 'hauptbetrieb' ? 'true' : 'false';
      company.subsidiary = company.headsubsidiary === 'nebenbetrieb' ? 'true' : 'false';
      company.main_businesses_part_time = company.headsubsidiary === 'main_businesses_part_time' ? 'true' : 'false';
      company.in_auxiliary_operation = company.headsubsidiary === 'in_auxiliary_operation' ? 'true' : 'false';
      company.company_id = this.companyId;
      const updateData = {
        company: [company],
      };
      this.registrationService.updateCompany(updateData, this.companyId).subscribe(() => {});
    } else {
      this.saveNewCompany();
    }
  }

  saveForm(): void {
    if (!this.routeData?.isRenewConcession) {
      this.doSaveForm();
      return;
    }

    this.confirmationService.confirm({
      message: this.translateService.translateString('license.confirm-renewal-message'),
      accept: () => {
        this.doSaveForm();
      },
      reject: () => this.confirmationService.close(),
    });
  }

  validateFormFields(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateFormFields(control);
      }
    });
  }

  private setTechnicianApplicationForm(): any {
    const technician = this.technicianDataFG.value;
    this.addEducationInformationData(technician);
    return {
      technician_application: [
        {
          technician: [technician],
        },
      ],
    };
  }

  fileEvent(): void {
    // this.getTechnicianApplication();
    this.fileChanged = true;
    const technicianId: string = this.localStorageService.getItem('technician_id');
    this.registrationService.getTechnicianApplication(technicianId, 'technician_id').subscribe((response: any) => {
      this.isLoading = false;
      this.technicianApplication.document = response.technician_application[0].document;
      this.parseDocumentValues();
    });
  }

  private doSaveForm(): void {
    if (this.companyDataFG.valid && this.technicianDataFG.valid && this.educationInformationDataFG) {
      this.updateCompany();
      this.updateTechnician();

      const technician = this.technicianDataFG.value;
      const updateData = {
        technician_application: [
          {
            status: this.routeData?.isRenewConcession ? ConcessionStatus.renew_requested : ConcessionStatus.submitted,
            technician_id: this.technicianId,
            technician: [{ role: UserRoles.standardTechnician }],
            qualification_type: technician.qualification_type,
          },
        ],
      };
      this.deleteFiles();
      const technicianId: string = this.localStorageService.getItem('technician_id');
      this.registrationService.updateTechnicianApplication(updateData, this.taId).subscribe(() => {
        this.submitted = true;

        this.registrationService.getTechnicianApplication(technicianId, 'technician_id').subscribe((response: ApplicationResponseData) => {
          this.isLoading = false;
          this.ngOnInit();
        });
      });
    } else {
      this.validateFormFields(this.companyDataFG);
      this.validateFormFields(this.technicianDataFG);
    }
  }

  private setFormValues(response: any): void {
    if (response && response.technician_application && response.technician_application.length) {
      this.technicianApplication = response.technician_application[0];
      if (
        this.technicianApplication &&
        this.technicianApplication.status &&
        (this.technicianApplication.status === ConcessionStatus.submitted || this.technicianApplication.status === ConcessionStatus.granted)
      ) {
        this.submitted = true;
      } else {
        this.taId = this.technicianApplication.ta_id;
        this.companyId = this.technicianApplication.company_id;
        this.technicianId = this.technicianApplication.technician_id;

        this.parseDocumentValues();

        if (this.technicianApplication.technician && this.technicianApplication.technician.length) {
          this.technicianApplication.technician[0].qualification_type = this.technicianApplication.qualification_type;
          this.technicianDataFG.patchValue(this.technicianApplication.technician[0]);
          const checkData = {
            power: this.technicianApplication.technician[0].concession_power === '1',
            gas: this.technicianApplication.technician[0].concession_gas === '1',
            water: this.technicianApplication.technician[0].concession_water === '1',
            heating: this.technicianApplication.technician[0].concession_district_heating === '1',
            license: this.technicianApplication.technician[0].welding_license === '1' ? 'withLicense' : 'withoutLicense',
          };
          this.checkDataFG.patchValue(checkData);

          const educationInformationData = this.technicianApplication.technician[0]?.education_information;
          this.setEducationInformation(educationInformationData);
        } else {
          this.technicianDataFG.reset();
          this.checkDataFG.reset();
          this.educationInformationDataFG.reset();
        }
        this.validateFormFields(this.technicianDataFG);
        this.validateFormFields(this.checkDataFG);
        if (this.technicianApplication.company && this.technicianApplication.company.length) {
          const companyData = this.technicianApplication.company[0];
          if (companyData.headoffice === 'true') {
            companyData.headsubsidiary = 'hauptbetrieb';
          }
          if (companyData.subsidiary === 'true') {
            companyData.headsubsidiary = 'nebenbetrieb';
          }
          if (companyData.main_businesses_part_time === 'true') {
            companyData.headsubsidiary = 'main_businesses_part_time';
          }
          if (companyData.in_auxiliary_operation === 'true') {
            companyData.headsubsidiary = 'in_auxiliary_operation';
          }
          companyData.company_id = this.technicianApplication.technician[0].company_id;
          this.companyDataFG.patchValue(companyData);
        } else {
          this.companyDataFG.reset();
        }
        this.validateFormFields(this.companyDataFG);
      }
    }
  }

  private parseDocumentValues(): void {
    if (this.technicianApplication && this.technicianApplication.document) {
      this.documents = this.technicianApplication.document.map(data => {
        if (data.filesize.length > 3) {
          data.filesize = (data.filesize / 1000).toFixed(2) + ' kb';
        } else {
          data.filesize = data.filesize + ' bytes';
        }
        return data;
      });
    }
  }

  getLicenseEnabled(): boolean {
    const checkData = this.checkDataFG.value;
    if (checkData && checkData.license && checkData.license === 'withLicense') {
      return this.getButtonEnabled('welding_certificate_confirmation');
    }
    return false;
  }

  getButtonEnabled(type: string): boolean {
    const isEnabled: boolean = this.fileService.checkForAvailableDocuments(this.documents, type);
    return isEnabled !== true;
  }

  enabledRadioButtons(): boolean {
    const checkData = this.checkDataFG.value;
    return checkData && checkData.heating;
  }

  enabledFileUpload(): boolean {
    const checkData = this.checkDataFG.value;
    return checkData && checkData.license && checkData.license === 'withLicense';
  }

  enableHeatingWeldingCertificateConfirmation(): boolean {
    const checkData = this.checkDataFG.value;
    return checkData && checkData.heating && this.showHeatingWeldingCertificateConfirmation;
  }

  getFileEnabled(fileType: string): boolean {
    const technicianData = this.technicianDataFG.value;
    if (!technicianData.qualification_type) {
      return true;
    }

    const fileTypeQualificationsMap: { [key: string]: string[] } = {
      proof_of_qualification: ['Meister', 'Ingenieur', 'Meister In anderem Handwerk', 'Altgeselle'],
      proof_of_expertise: ['Ausnahmebewilligung', 'Ingenieur', 'Meister In anderem Handwerk', 'Altgeselle'],
      proof_of_contract: ['Ausnahmebewilligung', 'Altgeselle'],
    };

    const fileTypeQualifications = fileTypeQualificationsMap[fileType] || [];

    return !!fileTypeQualifications.find(q => technicianData.qualification_type === q);
  }

  addMandatoryDocumentsByQualification(shouldAddForAllCommodities?: boolean): void {
    const technicianData = this.technicianDataFG.value;
    if (shouldAddForAllCommodities) {
      this.mandatoryDocumentsByQualificationAndCommodity
        ?.find(docs => docs.qualification === technicianData.qualification_type)
        ?.documents.forEach(d => this.specialistMandatoryDocumentsTypes.add(d));
    } else {
      this.mandatoryDocumentsByQualificationAndCommodity
        ?.find(
          docs =>
            docs.qualification === technicianData.qualification_type &&
            docs.commodities.some(
              commodity => this.checkDataFG.value.hasOwnProperty(commodity) && this.checkDataFG.value[commodity] === true
            )
        )
        ?.documents.forEach(doc => this.specialistMandatoryDocumentsTypes.add(doc));
    }
  }

  deleteFiles(): void {
    const technicianData = this.technicianDataFG.value;
    const checkData = this.checkDataFG.value;
    if (technicianData.qualification_type === 'Meister') {
      const document: DocumentData[] = this.fileService.getDimensionsByFilter(this.documents, FileData.PROOFOFEXPERTISE);
      if (document !== null && document !== undefined && document.length) {
        this.removeFile(document[0].document_id);
      }
    }
    if (
      technicianData.qualification_type === 'Meister' ||
      technicianData.qualification_type === 'Ingenieur' ||
      technicianData.qualification_type === 'Meister In anderem Handwerk'
    ) {
      const document: DocumentData[] = this.fileService.getDimensionsByFilter(this.documents, FileData.PROOFOFCONTRACT);
      if (document !== null && document !== undefined && document.length) {
        this.removeFile(document[0].document_id);
      }
    }
    if (technicianData.qualification_type === 'Ausnahmebewilligung') {
      const document: DocumentData[] = this.fileService.getDimensionsByFilter(this.documents, FileData.PROOFOFQUALIFICATION);
      if (document !== null && document !== undefined && document.length) {
        this.removeFile(document[0].document_id);
      }
    }
    if (!checkData.heating || checkData.license === null || checkData.license === '' || checkData.license === 'withoutLicense') {
      const document: DocumentData[] = this.fileService.getDimensionsByFilter(this.documents, FileData.WELDINGCERTIFICATECONFIRMATION);
      if (document !== null && document !== undefined && document.length) {
        this.removeFile(document[0].document_id);
      }
    }
  }

  removeFile(documentId: string): void {
    this.fileService.removeFile(documentId).subscribe(() => {
      const index = this.fileService.checkIndex(this.documents, documentId);
      if (index !== -1) {
        this.documents.splice(index, 1);
      }
      this.ref.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.registrationService.technicianDataFG.reset();
    this.registrationService.companyDataFG.reset();
    this.registrationService.educationInformationDataFG.reset();
  }

  allTakeMandatoryDocumentsUploaded(): boolean {
    return (
      this.companyExist ||
      ([
        ...this.takeMandatoryDocumentsTypes,
        ...((this.showProofOfVdeSubscriptionDocument && this.checkDataFG?.value.power && [FileData.PROOFOFVDESUBSCRIPTION]) || []),
      ].every(mandatoryDoc => this.documents.some(doc => doc.name === mandatoryDoc)) &&
        [...this.specialistMandatoryDocumentsTypes]
          .filter(e => !this.optionalDocumentsTypes.has(e))
          .every(mandatoryDoc => this.documents.some(doc => doc.name === mandatoryDoc)))
    );
  }

  updateValidation() {
    if (this.showBaseDataEmail) {
      this.companyDataFG.controls.email.setValidators([Validators.required, ValidationsService.emailValidator()]);
      this.companyDataFG.controls.email.updateValueAndValidity();
    }

    if (this.showTechnicianDataEmail) {
      this.technicianDataFG.controls.email.setValidators([Validators.required, ValidationsService.emailValidator()]);
      this.technicianDataFG.controls.email.updateValueAndValidity();
    }

    if (this.showMastersExaminationOn) {
      this.technicianDataFG.controls.qualification_issued_on.setValidators([Validators.required]);
      this.technicianDataFG.controls.qualification_issued_on.updateValueAndValidity();
    }
  }

  updateEducationDateInformation(data: string): void {
    switch (data) {
      case 'journeyman_training_on':
        const journeymanTrainingOn = this.educationInformationDataFG.value.journeyman_training_on;
        if (journeymanTrainingOn) {
          this.educationInformationDataFG.value.journeyman_training_on = this.convertDateToSavingFormat(journeymanTrainingOn);
        }
        break;
      case 'diploma_technician_on':
        const diplomaTechnicianOn = this.educationInformationDataFG.value.diploma_technician_on;
        if (diplomaTechnicianOn) {
          this.educationInformationDataFG.value.diploma_technician_on = this.convertDateToSavingFormat(diplomaTechnicianOn);
        }
        break;
      case 'university_or_technical_college_degree_on':
        const universityOrTechnicalCollegeDegreeOn = this.educationInformationDataFG.value.journeyman_training_on;
        if (universityOrTechnicalCollegeDegreeOn) {
          this.educationInformationDataFG.value.journeyman_training_on = this.convertDateToSavingFormat(
            universityOrTechnicalCollegeDegreeOn
          );
        }
        break;
    }
    this.updateTechnician();
  }

  updateEducationOnValidators(educationType: string): void {
    switch (educationType) {
      case 'journeyman_training_as':
        if (this.educationInformationDataFG.controls.journeyman_training_as.value) {
          this.educationInformationDataFG.controls.journeyman_training_on.setValidators([Validators.required]);
        } else {
          this.educationInformationDataFG.controls.journeyman_training_on.setValue('');
          this.educationInformationDataFG.controls.journeyman_training_on.clearValidators();
        }
        break;
      case 'diploma_technician_specialization':
        if (this.educationInformationDataFG.controls.diploma_technician_specialization.value) {
          this.educationInformationDataFG.controls.diploma_technician_on.setValidators([Validators.required]);
        } else {
          this.educationInformationDataFG.controls.diploma_technician_on.setValue('');
          this.educationInformationDataFG.controls.diploma_technician_on.clearValidators();
        }
        break;
      case 'university_or_technical_college_degree_specialty':
        if (this.educationInformationDataFG.controls.university_or_technical_college_degree_specialty.value) {
          this.educationInformationDataFG.controls.university_or_technical_college_degree_on.setValidators([Validators.required]);
        } else {
          this.educationInformationDataFG.controls.university_or_technical_college_degree_on.setValue('');
          this.educationInformationDataFG.controls.university_or_technical_college_degree_on.clearValidators();
        }
        break;
    }

    this.educationInformationDataFG.controls.journeyman_training_on.updateValueAndValidity();
    this.updateTechnician();
  }

  convertDateToSavingFormat(inputDate: any): string {
    if (typeof inputDate === 'object') {
      return this.commonService.convertDateObject(inputDate);
    }

    if (inputDate.includes('.')) {
      return this.commonService.parseDateForSaving(inputDate);
    }

    return inputDate;
  }

  setMandatoryDocuments(commodityType: string, checkData: any): void {
    if (!commodityType) {
      return;
    }

    switch (commodityType) {
      case 'power':
        if (checkData[commodityType]) {
          this.updateRequiredDocumentsAfterEmptyChecks();
          this.mandatoryDocumentsPerCommodity.power.documentsCompany.forEach(d => this.takeMandatoryDocumentsTypes.add(d));
          this.mandatoryDocumentsPerCommodity.power.documentsSpecialist.forEach(d => this.specialistMandatoryDocumentsTypes.add(d));
        } else {
          this.setRequiredDocuments(checkData);
        }
        break;
      case 'gas':
        if (checkData[commodityType]) {
          this.updateRequiredDocumentsAfterEmptyChecks();
          this.mandatoryDocumentsPerCommodity.gas.documentsCompany.forEach(d => this.takeMandatoryDocumentsTypes.add(d));
          this.mandatoryDocumentsPerCommodity.gas.documentsSpecialist.forEach(d => this.specialistMandatoryDocumentsTypes.add(d));
        } else {
          this.setRequiredDocuments(checkData);
        }
        break;
      case 'water':
        if (checkData[commodityType]) {
          this.updateRequiredDocumentsAfterEmptyChecks();
          this.mandatoryDocumentsPerCommodity.water.documentsCompany.forEach(d => this.takeMandatoryDocumentsTypes.add(d));
          this.mandatoryDocumentsPerCommodity.water.documentsSpecialist.forEach(d => this.specialistMandatoryDocumentsTypes.add(d));
        } else {
          this.setRequiredDocuments(checkData);
        }
        break;
      case 'heating':
        if (checkData[commodityType]) {
          this.updateRequiredDocumentsAfterEmptyChecks();
          this.mandatoryDocumentsPerCommodity.districtHeating.documentsCompany.forEach(d => this.takeMandatoryDocumentsTypes.add(d));
          this.mandatoryDocumentsPerCommodity.districtHeating.documentsSpecialist.forEach(d =>
            this.specialistMandatoryDocumentsTypes.add(d)
          );
        } else {
          this.setRequiredDocuments(checkData);
        }
        break;
    }

    this.addMandatoryDocumentsByQualification();
  }

  isSendRequestButtonDisabled(): boolean {
    return (
      !this.companyDataFG.valid ||
      !this.technicianDataFG.valid ||
      this.getLicenseEnabled() ||
      !this.checkDataFG.valid ||
      !this.allTakeMandatoryDocumentsUploaded() ||
      !this.educationInformationDataFG.valid ||
      !(
        this.companyDataFG.dirty ||
        this.technicianDataFG.dirty ||
        this.checkDataFG.dirty ||
        this.educationInformationDataFG.dirty ||
        this.fileChanged
      )
    );
  }

  private setRequiredDocuments(checkData: any) {
    if (!checkData.power && !checkData.gas && !checkData.water && !checkData.heating) {
      this.setRequiredDocumentsOnEmptyChecks();
    } else {
      this.takeMandatoryDocumentsTypes = new Set([
        ...((checkData.power && this.mandatoryDocumentsPerCommodity.power.documentsCompany) || []),
        ...((checkData.gas && this.mandatoryDocumentsPerCommodity.gas.documentsCompany) || []),
        ...((checkData.water && this.mandatoryDocumentsPerCommodity.water.documentsCompany) || []),
        ...((checkData.heating && this.mandatoryDocumentsPerCommodity.districtHeating.documentsCompany) || []),
      ]);

      this.specialistMandatoryDocumentsTypes = new Set([
        ...((checkData.power && this.mandatoryDocumentsPerCommodity.power.documentsSpecialist) || []),
        ...((checkData.gas && this.mandatoryDocumentsPerCommodity.gas.documentsSpecialist) || []),
        ...((checkData.water && this.mandatoryDocumentsPerCommodity.water.documentsSpecialist) || []),
        ...((checkData.heating && this.mandatoryDocumentsPerCommodity.districtHeating.documentsSpecialist) || []),
      ]);
    }
  }

  private setOptionalDocuments(): void {
    const checkData = this.checkDataFG.value;
    this.optionalDocumentsTypes.clear();
    if (!checkData.power && !checkData.gas && !checkData.water && !checkData.heating) {
      this.setOptionalDocumentsByCommodityOnEmptyChecks();
      this.addMandatoryDocumentsByQualification(true);
    } else {
      if (this.optionalDocumentsByCommodity) {
        if (checkData.gas) {
          this.optionalDocumentsByCommodity
            .find(docs => docs.commodity === 'gas')
            .documents.forEach(doc => this.optionalDocumentsTypes.add(doc));
        }

        if (checkData.water) {
          this.optionalDocumentsByCommodity
            .find(docs => docs.commodity === 'water')
            .documents.forEach(doc => this.optionalDocumentsTypes.add(doc));
        }

        if (checkData.power) {
          this.optionalDocumentsByCommodity
            .find(docs => docs.commodity === 'power')
            .documents.forEach(doc => this.optionalDocumentsTypes.add(doc));
        }

        if (checkData.heating) {
          this.optionalDocumentsByCommodity
            .find(docs => docs.commodity === 'districtHeating')
            .documents.forEach(doc => this.optionalDocumentsTypes.add(doc));
        }
      }
    }
  }

  private setRequiredDocumentsOnEmptyChecks() {
    this.allDocumentsResultingOfEmptyChecks = true;
    this.takeMandatoryDocumentsTypes = new Set([
      ...this.mandatoryDocumentsPerCommodity.power.documentsCompany,
      ...this.mandatoryDocumentsPerCommodity.gas.documentsCompany,
      ...this.mandatoryDocumentsPerCommodity.water.documentsCompany,
      ...this.mandatoryDocumentsPerCommodity.districtHeating.documentsCompany,
    ]);

    this.specialistMandatoryDocumentsTypes = new Set([
      ...this.mandatoryDocumentsPerCommodity.power.documentsSpecialist,
      ...this.mandatoryDocumentsPerCommodity.gas.documentsSpecialist,
      ...this.mandatoryDocumentsPerCommodity.water.documentsSpecialist,
      ...this.mandatoryDocumentsPerCommodity.districtHeating.documentsSpecialist,
    ]);
  }

  private setOptionalDocumentsByCommodityOnEmptyChecks(): void {
    this.optionalDocumentsByCommodity?.forEach(doc => doc.documents.forEach(d => this.optionalDocumentsTypes.add(d)));
  }

  private updateRequiredDocumentsAfterEmptyChecks() {
    if (this.allDocumentsResultingOfEmptyChecks) {
      this.takeMandatoryDocumentsTypes = new Set<string>();
      this.specialistMandatoryDocumentsTypes = new Set<string>();

      this.allDocumentsResultingOfEmptyChecks = false;
    }
  }

  private addEducationInformationData(technician: any): void {
    const educationInformationData = this.educationInformationDataFG.value;
    if (educationInformationData) {
      technician.education_information = educationInformationData;
    }
  }

  private setEducationInformation(educationInformationData: any) {
    if (educationInformationData) {
      const educationInformation = {
        journeyman_training_as: educationInformationData.journeyman_training_as,
        diploma_technician_specialization: educationInformationData.diploma_technician_specialization,
        university_or_technical_college_degree_specialty: educationInformationData.university_or_technical_college_degree_specialty,
        journeyman_training_on: educationInformationData.journeyman_training_on,
        diploma_technician_on: educationInformationData.diploma_technician_on,
        university_or_technical_college_degree_on: educationInformationData.university_or_technical_college_degree_on,
      };
      this.educationInformationDataFG.patchValue(educationInformation);
    }
  }

  private setEducationInformationSectionVisibility(): void {
    this.showEducationInformationSection =
      this.environmentService.showEducationInformationSection && !(this.checkDataFG.value?.water || this.checkDataFG.value?.gas);
  }

  private updateOptionalDocumentsByQualification() {
    const technicianData = this.technicianDataFG.value;

    const qualificationTypes = ['Meister', 'Ingenieur', 'Meister In anderem Handwerk', 'Ausnahmebewilligung', 'Altgeselle'];

    if (technicianData.qualification_type === 'Meister') {
      this.optionalDocumentsTypes.add(FileData.PROOFOFEXPERTISE);
    } else {
      this.optionalDocumentsTypes.delete(FileData.PROOFOFEXPERTISE);
    }
    if (
      technicianData.qualification_type === 'Meister' ||
      technicianData.qualification_type === 'Ingenieur' ||
      technicianData.qualification_type === 'Meister In anderem Handwerk'
    ) {
      this.optionalDocumentsTypes.add(FileData.PROOFOFCONTRACT);
    } else {
      this.optionalDocumentsTypes.delete(FileData.PROOFOFCONTRACT);
    }
    if (technicianData.qualification_type === 'Ausnahmebewilligung') {
      this.optionalDocumentsTypes.add(FileData.PROOFOFQUALIFICATION);
    } else {
      this.optionalDocumentsTypes.delete(FileData.PROOFOFQUALIFICATION);
    }

    if (technicianData?.qualification_type && qualificationTypes.includes(technicianData.qualification_type)) {
      this.optionalDocumentsByQualification
        ?.find(docs => docs.qualification === technicianData.qualification_type)
        ?.documents.forEach(doc => this.optionalDocumentsTypes.add(doc));
    }
  }

  private hideWaterCommodityIfNeeded() {
    if (this.environmentService.technicianRegistrationHideWaterCommodity) {
      this.commodities = this.commodities.filter(commodity => commodity !== 'water');
    }
  }
}
